import { Fare, FlightCard } from '@/src/types/flight'

export function constructSplrt(card: FlightCard, splRtFn: string) {
    if (!card || !splRtFn || !card?.priceBreakup?.SPLRT) return
    let splrtFare = 0
    let splrtFareWODiscount = 0
    let solutionId = ''
    let comboFareBasisCode = ''
    let splrtArray = Object.keys(card.priceBreakup && card.priceBreakup.SPLRT)
    let splrtDfd = ''
    let splrtFk = ''
    let splrtBp = 0
    let isSpecialRT = false
    let sFare = undefined
    let isSplrtRtFareCheaperThenRetail = false
    for (let i = 0; i < splrtArray.length; i++) {
        let currElement = splrtArray[i]
        let arraySplit = currElement.split(',')
        if (arraySplit.includes(splRtFn)) {
            const splrtElement = card['priceBreakup']['SPLRT'][currElement]
            const dfd = splrtElement['dfd'] as keyof typeof splrtElement
            splrtDfd = splrtElement['dfd']
            const fare = splrtElement[dfd] as Fare
            splrtFare = fare.pr
            splrtFareWODiscount = fare.pr + fare.ds
            isSpecialRT = true
            splrtBp = fare.bp
            splrtFk = fare.fk
            solutionId = fare?.solutionIdMap?.[splRtFn] || ''
            let fareGroupInformation = fare?.fareGroupInformation
            comboFareBasisCode =
                fareGroupInformation && fareGroupInformation.comboFareBasisCode
                    ? fareGroupInformation.comboFareBasisCode
                    : fare.fb
            sFare = fare
            isSplrtRtFareCheaperThenRetail = fare.pr < card.priceBreakup.pr
            break
        }
    }

    return {
        splrtFare,
        splrtFareWODiscount,
        solutionId,
        comboFareBasisCode,
        splrtFk,
        splrtDfd,
        splrtBp,
        isSpecialRT,
        sFare,
        isSplrtRtFareCheaperThenRetail
    }
}
